import StyledLink from '../StyledLink'
import {
  CONTROLLER,
  MONITOR,
  RESULTS
} from '../routes'
import { useModule } from '@eggplant/routing'
import type { Props } from '../types'

interface Params {
  isSubmodel?: boolean
  runId: number
}

const LinkToTestResultView = ({
  children,
  isSubmodel = false,
  runId,
  isHyperlink
}: Props & Params) => {
  const [isMonitorFlag] = useModule()

  const path = isMonitorFlag
    ? MONITOR
    : CONTROLLER

  const base = '/' + path + '/' + RESULTS

  const subModel = isSubmodel
    ? '?isSubmodel'
    : ''

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={`${base}/${runId}${subModel}`}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToTestResultView
